import { Component, EventEmitter, OnInit } from '@angular/core';
import { BaryModalEvent, IBaryModalEvent } from '../../../../../../models/bary-modal-event';
import { BaryComponentHelper } from '../../../../util/bary-component-helper';
import { BaryModalForm } from '../../../../../../models/bary-modal-form';
import { MDBModalRef } from 'ng-uikit-pro-standard';
import { Transporter } from '../../../../../../models/transporter.model';
import { HEADBAND_MESSAGE_OPTIONS } from '../../../../../../models/constants/headband-message.const';
import { Headband, HeadbandControls, IHeadband } from '../../../../../../models/headband.model';
import { mapAsBody } from '../../../../util/request-util';
import { TransporterService } from '../../../../../../services/transporter.service';
import { patchObject } from '../../../../util/object-util';
import { DisplayHeadbandModeratorService } from '../../../../../../services/display-headband-moderator.service';
import { IGenericBaryFormGroup } from '../../../../../../models/forms/GenericBaryFormGroup';
import { BaryFormFactoryService } from '../../../../../../services/bary-form-factory.service';

@Component({
  templateUrl: './bary-modal-add-or-update-headband.component.html',
})
export class BaryModalAddOrUpdateHeadbandComponent extends BaryModalForm implements OnInit {
  transporters?: Transporter[];
  optionsTransporter: { label: string; value: any }[] = [];
  options!: { isPickup: boolean };
  formGroup!: IGenericBaryFormGroup<HeadbandControls>;
  override action = BaryComponentHelper.generateAction<IBaryModalEvent>();
  override model: IHeadband = new Headband();
  _headbandMessageOptions = HEADBAND_MESSAGE_OPTIONS;
  forceRefreshOptions = new EventEmitter();
  id1 = BaryComponentHelper.makeId();
  id2 = BaryComponentHelper.makeId();
  controlerDatePicker?: string;
  startDate: Date | undefined;
  endDate: Date | undefined;

  constructor(
    public modalRef: MDBModalRef,
    private bcf: BaryFormFactoryService,
    private transporterService: TransporterService,
    private headbandService: DisplayHeadbandModeratorService
  ) {
    super();
  }

  ngOnInit(): void {
    this.formGroup = this.bcf.makeHeadbandForm(this.model);
    this.transporterService
      .query()
      .pipe(mapAsBody)
      .subscribe(transporters => {
        this.transporters = transporters;
        this.mapTransporters();
      });
    const array: number[] = [];
    if (this.formGroup.controls.transporterIds.value) {
      this.formGroup.controls.transporterIds.value.split(';').forEach((it: number) => {
        array.push(it);
      });
      this.formGroup.controls.transporters.setValue(array);
    }
  }

  mapTransporters(): void {
    const transportersArray: { label: string; value: string }[] = [];

    this.transporters?.forEach(item => {
      const formatedTransporters: { label: string; value: string } = {
        label: item.companyName!,
        value: item.id!.toString(),
      };
      transportersArray.push(formatedTransporters);
    });

    this.optionsTransporter = transportersArray;
  }

  //
  handleClick(from: any): void {
    this.action.next(new BaryModalEvent(from));
    this.modalRef.hide();
  }

  onStartDateChange(): boolean {
    this.endDate = new Date(this.formGroup.controls.endDate.value);
    this.startDate = new Date(this.formGroup.controls.startDate.value);
    this.controlerDatePicker = undefined;
    if (this.startDate.toDateString() === this.endDate.toDateString() || this.startDate > this.endDate) {
      this.controlerDatePicker = 'La date de début doit être inférieure à la date de fin.';
      this.formGroup.controls.startDate.markAsTouched();
      return true;
    }
    return false;
  }

  onEndDateChange(): boolean {
    this.endDate = new Date(this.formGroup.controls.endDate.value);
    this.startDate = new Date(this.formGroup.controls.startDate.value);

    this.controlerDatePicker = undefined;
    if (this.startDate.toDateString() === this.endDate.toDateString() || this.startDate > this.endDate) {
      this.controlerDatePicker = 'La date de début doit être inférieure à la date de fin.';
      this.formGroup.controls.endDate.markAsTouched();
      return true;
    }
    return false;
  }

  override handleSubmit(): void {
    if (!this.onEndDateChange() && !this.onEndDateChange()) {
      if (this.formGroup.getAngularForm().invalid) {
        this.formGroup.getAngularForm().markAllAsTouched();
        this.focusOnFirstError();
      } else {
        patchObject(this.model, this.formGroup.value);
        if (this.model.id) {
          this.modelBeforeUpdateCreation();
          this.headbandService.update(this.model).subscribe();
        } else {
          this.modelBeforeUpdateCreation();
          this.headbandService.create(this.model).subscribe();
        }
        this.action.next(new BaryModalEvent(this.model));
        this.modalRef.hide();
        this.forceRefreshOptions.subscribe();
        window.location.reload();
      }
    }
  }

  modelBeforeUpdateCreation(): void {
    this.formGroup.updateModel(this.model);
    let transporters = '';
    let i = 0;
    const transportersTemp = this.formGroup.controls.transporters.value;
    transportersTemp?.forEach((it: any) => {
      i++;
      if (i === 1) {
        transporters = it.toString();
      } else {
        transporters += ';' + it.toString();
      }
      if (transportersTemp.length === i) {
        this.model.transporterIds = transporters;
      }
    });
  }
}
